"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseThemePath = void 0;
var lodash_1 = require("lodash");
/**
 * Utility to return a value from a theme path.
 *
 * @param themePath
 * @param theme
 * @param defaultValue
 * @returns {*}
 */
var parseThemePath = function (themePath, theme, defaultValue) {
    if (themePath === 'transparent')
        return 'transparent';
    if (themePath === 'inherit')
        return 'inherit';
    if (themePath === 'light' || themePath === 'normal' || themePath === 'bold' || themePath === 'heavy' ||
        themePath === '300' || themePath === '400' || themePath === '700' || themePath === '900') {
        return themePath;
    }
    if (themePath && typeof themePath === 'string' && themePath.includes('#')
        || themePath && typeof themePath === 'string' && themePath.includes('%')
        || themePath && typeof themePath === 'string' && themePath.includes('px')
        || themePath && typeof themePath === 'string' && themePath.includes('rgba')) {
        return themePath;
    }
    return lodash_1.get(theme, themePath, defaultValue);
};
exports.parseThemePath = parseThemePath;
//# sourceMappingURL=index.js.map